import React from 'react';
import Image from '../../../img/MainWebsite/CruisesPage.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForCruises() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent  whiteFont'}>
        <div className={'column'}>
          <h2 className={'left blue'}>A THOUGHTFUL WAY TO PRESENT ONBOARD OFFERINGS </h2>
          <h5 className={'left'}>Designed for Cruise Operations: </h5>

          <ul className={"two-columns"}>
            <li className={'blue left'}><h5>Accessible on guests’ own phones or tablets  </h5></li>
            <li className={'blue left'}><h5>Presents dining, retail, spa, excursions, and onboard experiences in one place </h5></li>
            <li className={'blue left'}><h5>Supports guest exploration at their own pace  </h5></li>
            <li className={'blue left'}><h5>Reduces repetitive questions for crew during peak periods </h5></li>
            <li className={'blue left'}><h5>Generate an additional revenue stream  </h5></li>
            <li className={'blue left'}><h5>Integrates seamlessly into club operations </h5></li>
            <li className={'blue left'}><h5>Exclusively branded for your golf club</h5></li>
            <li className={'blue left'}><h5>No investment, no setup fees, no hardware, no training, no downloads, and no financial risk </h5></li>
          </ul>
          <h5 className={'left'}>Today’s cruise guests value clarity, convenience, and a well-orchestrated experience throughout their journey. Delivering that level of service across a ship requires tools that enhance communication and presentation—without adding operational complexity. </h5>
          <h5 className={'left'}>Vizo Menu provides a supplemental digital presentation layer, accessible on guests’ phones or tablets, that showcases dining options, retail offerings, spa services, shore excursions, and onboard experiences. Whether guests are poolside, in their stateroom, or exploring the ship, they can easily access relevant information at their own pace. </h5>
          <h5 className={'left'}>Designed to integrate seamlessly into the onboard experience and branded exclusively for your cruise line, Vizo Menu supports guest understanding while preserving existing service models. Providing clear context and helpful details upfront contributes to smoother interactions, more confident decisions, and a more cohesive onboarding experience. </h5>
          <h5 className={'left'}>Cruise lines can strengthen engagement, support operational efficiency, and introduce an additional revenue stream through handpicked integrated sponsorships that enhance—rather than interrupt—the guest journey, all without changing how the ship operates or how crew deliver service. </h5>
          <h5 className={'left'}>Best of all, Vizo Menu is provided at no investment. Our business model enables cruise lines to elevate onboard presentation and consistency with no setup fees, no hardware, no training, no downloads, and no financial risk. </h5>
          <h5 className={'blue left italic'}>A thoughtful enhancement—designed to complement the cruise experience, not compete with it. </h5>
        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background blue-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForCruises;